import memoize from 'memoize-one'
import isEqual from 'lodash/isEqual'

class Memoize {
  /**
   * shallow memoized
   * @param  {...any} args
   */
  shallowMemoized(...args) {
    return memoize(...args)
  }

  /**
   * deep memoized
   * @param {any} identity
   */
  deepMemoized(identity) {
    return memoize(identity, isEqual)
  }
}

export default new Memoize()
